// extracted by mini-css-extract-plugin
export default {"ace-c-google-places-logo":"google-places-logo---8cf41ca0"};